import { AbilityBuilder, createMongoAbility, type MongoAbility } from '@casl/ability'
import _ from 'lodash'

import type { AbilityUser } from './types'

export function defineAbilityFor(
  user: AbilityUser | null | undefined
): MongoAbility {
  const { can, build } = new AbilityBuilder(createMongoAbility)

  if (!user) return build()

  const roles = _.get(user, 'roles', [user.main_role])
  const identities = _.get(user, 'identities', [])

  can('manage', 'Order', { user_id: user?.id })
  can('transfer', 'Ticket', { 'user.id': user?.id })

  identities.forEach(identity => {
    if (identity.provider === 'brasiljunior') {
      const providerUIDs = _.get(identity, 'meta.provider_uids', []) || []

      if (providerUIDs.includes('')) {
        can('manage', 'Partner', { slug: 'brasiljunior' })
      }

      if (providerUIDs.find(uid => uid.includes('Federation'))) {
        can('manageGroup', 'Partner', {
          slug: 'brasiljunior',
          group: 'federations'
        })
      }

      if (providerUIDs.find(uid => uid.includes('Core'))) {
        can('manageGroup', 'Partner', {
          slug: 'brasiljunior',
          group: 'cores'
        })
      }

      if (providerUIDs.find(uid => uid.includes('Ej'))) {
        can('manageGroup', 'Partner', {
          slug: 'brasiljunior',
          group: 'ejs'
        })
      }
    }
  })

  roles.forEach(role => {
    if (
      role?.client_id == null &&
      (_.get(role, 'permission_names', []).includes(':') ||
        role?.slug == 'admin')
    ) {
      can('manage', 'all')
      can('manage', 'All')
    }

    if (role?.slug == 'financial_manager') {
      can('manage', 'LooseOrder')
    }

    if (role?.slug == 'manager') {
      can('manage', 'IDigitalProduct', { client_id: role?.client_id })
    }

    if (role?.slug == 'gamification_support') {
      can('support', 'IDigitalProduct', { client_id: role?.client_id })
    }
  })

  return build()
}
